if (document.querySelectorAll('.td-product-details__accordion .summary-wrapper').length > 0) {
    document.querySelectorAll('.td-product-details__accordion .summary-wrapper').forEach((item, index) => {
        item.addEventListener('click', () => {
            const accordion = document.querySelectorAll('.td-product-details__accordion')[index];
            if (accordion.querySelector('.accordion__content')) {
                
                if (accordion.querySelector('.accordion__content').classList.contains('active')) {
                    accordion.querySelector('.accordion__content').classList.remove('active');
                    accordion.querySelector('.icon-minus').style.display = "none";
                    accordion.querySelector('.icon-plus').style.display = "block";
                } else {
                    accordion.querySelector('.accordion__content').classList.add('active');
                    accordion.querySelector('.icon-minus').style.display = "block";
                    accordion.querySelector('.icon-plus').style.display = "none";
                }
            }
        })
    })
}